
import { Store } from 'pullstate';

// Persist draft answers in localStorage so that they won't disappear on page refresh
let initialDraftAnswers;
try {
  initialDraftAnswers = JSON.parse(localStorage.getItem('draftAnswers'));
} catch {
  // Ignore
}

export const store = new Store({
  authenticationHash: null,
  email: null,
  plans: null,
  draftAnswers: initialDraftAnswers || {},
  isLoggedIn: null,
});

store.subscribe((s) => s.draftAnswers, (draftAnswers) => {
  localStorage.setItem('draftAnswers', JSON.stringify(draftAnswers));
});

export function resetStore() {
  localStorage.removeItem('draftAnswers');

  store.update((s) => {
    s.authenticationHash = null;
    s.email = null;
    s.plans = null;
    s.draftAnswers = {};
    s.isLoggedIn = null;
  })
}